import { Button } from '@/components/ui/button';
import { ArrowLeft, History } from 'lucide-react';

interface CustomerDetailErrorProps {
  error?: string | null;
  onRetry?: () => void;
  onBack?: () => void;
}

export function CustomerDetailError({ error, onRetry, onBack }: CustomerDetailErrorProps) {
  return (
    <div className="flex-1 overflow-auto bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto py-6 max-w-4xl">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
            <h2 className="text-xl font-semibold text-red-600 mb-2">Error Loading Customer</h2>
            <p className="text-gray-600 mb-4">
              {error || "We couldn't load the customer details."}
            </p>
            <div className="flex justify-center gap-4">
              {onRetry && (
                <Button variant="outline" className="gap-2" onClick={onRetry}>
                  <History className="w-4 h-4" /> Try Again
                </Button>
              )}
              {onBack && (
                <Button variant="outline" className="gap-2" onClick={onBack}>
                  <ArrowLeft className="w-4 h-4" /> Back to Customers
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
